<template>
  <v-data-table
    ref="table"
    v-scroll:#data-section="onScroll"
    :headers="headers"
    :items="projectsToShow"
    :disable-pagination="true"
    :custom-sort="sortData"
    :hide-default-footer="true"
    :must-sort="true"
    sortBy="displayName"
    item-key="_id"
    class="data-table elevation-1"
    :mobile-breakpoint="0"
    @click:row="selectRow"
  >
    <template v-slot:item.displayName="{ item }">
      <div class="sdg-patch-container">
        <div
          v-for="sdg in item.data.sdg"
          :key="item.data.project_id + sdg"
          :sdg="sdg"
          :style="{backgroundColor: sdgByCode[sdg].color}"
          :title="sdgByCode[sdg].text"
          class="patch"
        />
      </div>
      {{ item.displayName }}
    </template>
    <template v-slot:item.data.budget="{ item }">{{ formatToCurrency(item.data.budget) }}</template>
  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'
import numbro from 'numbro'
import optionsData from '@/data/options'

const currencyFormat = {
  average: true,
  mantissa: 2,
  optionalMantissa: true,
  currencyPosition: 'prefix',
}

export default {
  name: 'projects-table',
  data() {
    return {
      headers: [
        {
          text: 'Project',
          align: 'left',
          value: 'displayName',
        },
        { text: 'Country', value: 'baseCountry' },
        { text: 'Budget', value: 'data.budget' },
      ],
      rowsNumber: 20,
      sort: {
        by: 'displayName',
        isDesc: false,
      }
    }
  },
  computed: {
    projects() {
      return this.$store.getters['projects/inBoundsProjects']
    },
    sdgByCode() {
      return optionsData.sdgOptions.reduce((acc, item) => {
        acc[item.code] = item
        return acc
      }, {})
    },
    projectsToShow() {
      const copy = [].concat(this.projects)
      const sortBy = this.sort.by
      const isDesc = this.sort.isDesc
      const res = copy.sort((a, b) => {
        const first = get(a, sortBy)
        const second = get(b, sortBy)
        if (isDesc) {
          if (second === undefined) {
            return 1
          }
          return second > first ? 1 : -1
        } else {
          if (first === undefined) {
            return 1
          }
          return first > second ? 1 : -1
        }
      }).slice(0, this.rowsNumber)
      return res
    },
  },
  methods: {
    ...mapActions({
      setCard: 'map/setCard',
    }),
    selectRow(v) {
      const data = Object.assign({}, v)
      data.kind = 'project'
      this.setCard(data)
      const desktopWidth = 1024
      if (window.innerWidth < desktopWidth) {
        this.$vuetify.goTo('#map-section')
      }
    },
    formatToCurrency(v) {
      return `$${numbro(v).format(currencyFormat)}`
    },
    onScroll(e) {
      const el = e.target
      if (Math.abs(el.scrollTop - el.scrollHeight + el.offsetHeight) < 1) {
        if (this.projects.length > this.rowsNumber) {
          this.rowsNumber += 20
        }
      }
    },
    sortData(items, sortBy, isDesc) {
      this.sort.by = sortBy[0]
      this.sort.isDesc = isDesc[0]
      return items
    }
  },
}
</script>

<style lang="scss" scoped>
.data-table ::v-deep tbody tr {
  cursor: pointer;
  border: none;
  &:nth-child(odd) {
    background-color: #f4f5fa;
  }
}
.data-table ::v-deep th {
  padding: 0 3px;
  white-space: nowrap;
  border-bottom: none !important;
}
.data-table ::v-deep tbody td {
  font-size: 12px;
  padding: 10px 3px;
  border-bottom: none !important;
  position: relative;
  vertical-align: top;
}
.data-table ::v-deep {
  & th,
  & td {
    &:first-child {
      padding-left: 34px;
    }
    &:last-child {
      padding-right: 34px;
    }
  }
}
.data-table ::v-deep tbody tr :first-child {
  font-weight: bold;
}
.sdg-patch-container {
  position: absolute;
  left: 20px;
  top: 16px;
  bottom: 6px;
  overflow: hidden;
  .patch {
    width: 6px;
    height: 6px;
    margin-bottom: 3px;
  }
}
</style>
